<template>
  <div class="jiejuefangan home baozhang ruzhu">
    <div id="nav" class="header">
      <head-top></head-top>
      <div class="default-title">
        <div class="default-title-top">加入师傅团队</div>
        <div class="default-title-bottom">加入聚师傅，获取更多订单资源</div>
      </div>
    </div>

    <div class="fangan-main">
      <div class="ruzhu-tuandui">
        <div class="fangan-problem">
          <div class="fangan-problem-items">
            <div
              class="fangan-problem-item"
              v-for="(item, index) in problemList"
              :key="index"
            >
              <div style="height:140px;margin-top:10px;"></div>
              <svg class="icon hide-icon" aria-hidden="true">
                <use :xlink:href="'#' + item.icon" />
              </svg>
              <svg class="icon hover-icon" aria-hidden="true">
                <use :xlink:href="'#' + item.hover" />
              </svg>
              <div class="fangan-problem-title">{{ item.title }}</div>
              <div class="fangan-problem-content">{{ item.content }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="ruzhu-process">
        <div class="fangan-title">接单流程</div>
        <div class="ruzhu-process-info">
          <div
            class="process-box"
            v-for="(item, index) in stepsList"
            :key="index"
          >
            <div class="process-border">
              <span class="ruzhu-process-stepnum">{{ index + 1 }}</span>
              <div class="process-ball">{{ item }}</div>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#iconjiantou" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      <div class="ruzhu-join">
        <div class="ruzhu-join-bg"></div>
        <div class="ruzhu-join-shifu-box">
          <div class="ruzhu-join-shifu">
            <div class="fangan-title">加入师傅团队</div>
            <div class="ruzhu-city-text">选择服务区域获取加入方法</div>
            <div class="ruzhu-select-city">
              <el-select
                v-model="citys.province"
                @change="getCityList('province')"
                placeholder="省"
                class="default-input"
              >
                <el-option
                  v-for="item in allProvinceList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                ></el-option>
              </el-select>
              <el-select
                v-model="citys.city"
                @change="getCityList('city')"
                :disabled="citys.province == ''"
                placeholder="市"
                class="default-input"
              >
                <el-option
                  v-for="item in cityList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                ></el-option>
              </el-select>
              <el-select
                v-model="citys.area"
                :disabled="citys.city == ''"
                placeholder="区/县"
                class="default-input"
              >
                <el-option
                  v-for="item in areaList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                ></el-option>
              </el-select>
            </div>
            <el-button class="ruzhu-submit" @click="getRuzhu()">确定</el-button>
            <div class="ruzhu-result" v-show="shiInfo">
              <div class="ruzhu-success" v-if="serviceList.length > 0">
                <div class="ruzhu-success-title">
                  1、下载师傅APP，并登录注册<span
                    >（请先登录，否则无法开通服务）</span
                  >
                </div>
                <canvas id="canvas"></canvas>
                <span class="download">扫描下载APP</span>
                <div class="ruzhu-success-title">
                  2、联系区域负责人，可快速开通服务（或者在APP提交服务开通申请）
                </div>
                <div
                  class="ruzhu-services"
                  v-for="(item, index) in serviceList"
                  :key="index"
                >
                  <div class="ruzhu-info ruzhu-type">
                    服务类型：{{ item.goodsTypeName }}
                  </div>
                  <div class="ruzhu-info">负责人：{{ item.contactName }}</div>
                  <div class="ruzhu-info">联系电话：{{ item.contactTel }}</div>
                </div>
              </div>
              <div class="ruzhu-fail" v-if="serviceList.length == 0">
                <img src="~@/assets/img/pic_noting.png" alt />
                该区域暂无服务商
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headTop from "./../../components/headTop";
import QRCode from "qrcode";
export default {
  components: {
    headTop,
    QRCode
  },
  data() {
    return {
      problemList: [
        {
          icon: "iconwendingshouyi_nor",
          hover: "iconwendingshouyi_hov",
          title: "稳定收益",
          content:
            "聚师傅对接各大家居生产企业，保证入驻平台的师傅有更多接到订单的机会"
        },
        {
          icon: "iconjishidingdantuisong_nor",
          hover: "iconjishidingdantuisong_hov",
          title: "即时的订单推送",
          content:
            "聚师傅通过微信平台即时推送您服务区域内的订单，根据信息提示即可快速查看详情"
        },
        {
          icon: "iconzijintuoguan_nor",
          hover: "iconzijintuoguan_hov",
          title: "资金全程托管",
          content:
            "订单费用全程由聚师傅平台托管，消费者确认安装完成后系统会自动把收益划入您的账户"
        }
      ],
      stepsList: ["提交订单", "师傅接单", "上门安装", "客户评分", "获得报酬"],
      citys: {
        province: "",
        city: "",
        area: ""
      },
      cityList: [],
      areaList: [],
      shiInfo: false,
      allProvinceList: [],
      serviceList: [{ goodsTypeName: "", contactName: "", contactTel: "" }] // 服务商数组
    };
  },
  mounted() {
    this.getProvinceList();
    this.urlCode();
  },
  methods: {
    bannerCheck(item, index) {
      this.bannerIndex = index;
      for (let i of this.bannerTab) {
        i.isSelected = false;
      }
      item.isSelected = true;
    },
    urlCode() {
      var _this = this;

      var canvas = document.getElementById("canvas");

      QRCode.toCanvas(canvas, location.origin + "/isDownload");
    },
    // 获取所有省code
    getProvinceList() {
      this.$fetch(`/common/api/area/all_province`).then(res => {
        if (res.code == 0) {
          this.allProvinceList = res.data;
        } else {
          this.$message(res.message);
        }
      });
    },
    // 根据省code获取市区数据
    getCityList(tag) {
      this.$fetch(`/common/api/area/area_children`, {
        parentCode: tag == "province" ? this.citys.province : this.citys.city
      }).then(res => {
        if (res.code == 0) {
          if (tag == "city") {
            this.areaList = res.data;
            this.citys.area = "";
          } else {
            this.cityList = res.data;
            this.citys.city = "";
            this.citys.area = "";
          }
        } else {
          this.$message(res.message);
        }
      });
    },
    // 查询改区域服务商
    getRuzhu() {
      this.$message.closeAll()
      if (this.citys.area == "") {
        this.$message("请先选择到区域，在执行此操作！");
        return;
      }
      this.$fetch(`/common/api/goods_type/area_services`, {
        areaCode: this.citys.area
      }).then(res => {
        if (res.code == 0) {
          console.log(res.data);
          this.serviceList = res.data;
          this.shiInfo = true;
        } else {
          this.$message(res.message);
        }
      });
    }
  }
};
</script>
<style lang="scss">
.ruzhu {
  #nav {
    background: url("../../assets/img/ruzhu_banner.jpg") no-repeat;
    background-size: cover;
    background-position: center;
    .head-rightBottom {
      .ruzhu {
        border-bottom: 2px solid #fff;
      }
    }
  }
  .fangan-main {
    margin-top: 0;
    .ruzhu-tuandui {
      background: #f5f7fc;
    }
    .fangan-problem {
      padding-top: 80px;
      height: 502px;
      .fangan-problem-items {
        margin-top: 0;
      }
      .fangan-problem-item {
        background: #fff;
        width: 392px;
        height: 322px;
        .icon {
          width: 140px;
          height: 140px;
          top: 10px;
        }
        .fangan-problem-title {
          margin-top: 20px;
        }
        .fangan-problem-content {
          padding: 0 47px;
          margin-top: 20px;
        }
      }
    }

    .ruzhu-join {
      margin-top: 133px;
      .ruzhu-join-bg {
        height: 300px;
        background: url("../../assets/img/ruzhu_banner2.jpg") no-repeat;
        background-size: cover;
        background-position: center;
      }
      .ruzhu-join-shifu-box {
        width: 1200px;
        margin: 0 auto;
        .ruzhu-join-shifu {
          width: 594px;
          // height: 278px;
          background: rgba(255, 255, 255, 1);
          box-shadow: 0px 5px 14px 0px rgba(18, 31, 80, 0.08);
          margin-top: -198px;
          padding: 40px 100px;
          .fangan-title {
            height: 32px;
            line-height: 1;
            text-align: left;
          }
          .ruzhu-city-text {
            height: 16px;
            font-size: 16px;
            color: rgba(94, 96, 102, 1);
            line-height: 1;
            margin-top: 40px;
          }
          .ruzhu-select-city {
            margin-top: 20px;
            .default-input {
              width: 120px;
              margin-right: 16px;
              input {
                width: 100%;
              }
              .el-input__suffix {
                width: auto;
              }
            }
            .default-input:last-child {
              margin-right: 0;
            }
          }
          .ruzhu-submit {
            width: 392px;
            height: 40px;
            background: rgba(52, 85, 211, 1);
            padding: 0;
            font-size: 14px;
            color: #ffffff;
            border-radius: 0;
            margin-top: 20px;
            border-color:rgba(52, 85, 211, 1);
          }
          .ruzhu-result {
            margin-top: 40px;
            #canvas{
              width: 148px !important;
              height: 148px !important;
            }
            .ruzhu-success {
              span.download {
                display: block;
                margin-bottom: 40px;
                padding-left: 32px;
                margin-top: -7px;
              }
            }
            .ruzhu-success-title {
              height: 14px;
              font-size: 14px;
              color: #2f3133;
              line-height: 1;
              font-weight: bold;
              white-space: nowrap;
              span {
                color: #ffad16;
              }
            }
            .ruzhu-info {
              height: 14px;
              font-size: 14px;
              color: rgba(47, 49, 51, 1);
              line-height: 1;
              margin-top: 16px;
            }
            .ruzhu-type {
              font-weight: bold;
            }
            .ruzhu-services {
              margin-bottom: 32px;
            }
            .ruzhu-fail {
              display: flex;
              font-size: 14px;
              color: #2f3133;
              align-items: center;
              justify-content: center;
              img {
                width: 72px;
                height: 72px;
              }
            }
          }
        }
      }
    }
  }
}
.ruzhu-process {
  margin-top: 100px;
  .ruzhu-process-info {
    width: 1200px;
    margin: 0 auto;
    margin-top: 92px;
    display: flex;
    .process-box {
      width: 240px;
      height: 179px;
      position: relative;
      padding: 25px 45px 4px 45px;
    }
    .process-box:last-child {
      .process-border {
        .icon {
          display: none;
        }
      }
    }
    .process-box:hover {
      .process-border {
        border: 1px solid #aeb9e1;
        padding: 36px;
        margin-left: -36px;
        margin-top: -36px;
        background: #fff;
        .icon {
          z-index: -1;
        }
        .ruzhu-process-stepnum {
          opacity: 0;
        }
        .process-ball {
          padding: 19px;
          color: #fff;
          box-shadow: 0px 10px 15px 1px rgba(17, 46, 161, 0.26);
          background: #3455d3;
          transform: scale(1.1);
          transform: rotate3d(1, 1, 1, 0);
        }
      }
    }
    .process-border {
      width: 150px;
      height: 150px;
      border: 1px dashed #bcc1cb;
      border-radius: 50%;
      //   position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: cubic-bezier(0.08, 0.82, 0.68, 1.06);
      transition-duration: 400ms;
      box-sizing: content-box;
      & > span,
      & > .icon {
        position: absolute;
      }
      .icon {
        width: 66px;
        right: -32px;
        top: 99px;
        color: #bcc1cb;
      }
      span {
        font-size: 100px;
        font-weight: 100;
        color: #eff2f6;
        right: 0;
        top: 0;
        height: 100px;
        width: 47px;
        line-height: 1;
        opacity: 1;
        transition: cubic-bezier(0.08, 0.82, 0.68, 1.06);
        transition-duration: 400ms;
      }
      .process-ball {
        width: 112px;
        height: 112px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        background: #f3f6ff;
        color: #2f3133;
        font-size: 20px;
        line-height: 1;
        transition: cubic-bezier(0.08, 0.82, 0.68, 1.06);
        transition-duration: 400ms;
        box-sizing: content-box;
      }
    }
  }
}
</style>
